__turbopack_context__.v({
  "map": "styles-module__R3wcBq__map",
  "mapContainer": "styles-module__R3wcBq__mapContainer",
});
